const scale = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  semiLg: '24px',
  lg: '32px',
  semiXl: '48px',
  xl: '64px',
  xxl: '96px',
  xxxl: '128px',
};
const array = [0, scale.xs, scale.sm, scale.md, scale.lg, scale.xl];
export default {
  ...array,
  ...scale,
};
